'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FontFace = function FontFace(familyFolderName, name, path) {
  var fontWeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'normal';
  var fontStyle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'normal';

  return '@font-face{\n    font-family: "' + name + '";\n    src: url(' + require('./' + familyFolderName + '/' + path + '.eot') + ');\n    src: url(' + require('./' + familyFolderName + '/' + path + '.eot') + ') format(\'embedded-opentype\'),\n          url(' + require('./' + familyFolderName + '/' + path + '.woff2') + ') format(\'woff2\'),\n          url(' + require('./' + familyFolderName + '/' + path + '.woff') + ') format(\'woff\'),\n          url(' + require('./' + familyFolderName + '/' + path + '.ttf') + ') format(\'truetype\'),\n          url(' + require('./' + familyFolderName + '/' + path + '.svg') + ') format(\'svg\');\n          \n    font-style: ' + fontStyle + ';\n    font-weight: ' + fontWeight + ';\n  }';
};

exports.default = FontFace;